var $f9b46437e610cca1$exports = {};
$f9b46437e610cca1$exports = {
  "dragItem": function dragItem(args) {
    return "Drag ".concat(args.itemText);
  },
  "dragSelectedItems": function dragSelectedItems(args, formatter) {
    return "Drag ".concat(formatter.plural(args.count, {
      one: function one() {
        return "".concat(formatter.number(args.count), " selected item");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " selected items");
      }
    }));
  },
  "dragDescriptionKeyboard": "Press Enter to start dragging.",
  "dragDescriptionKeyboardAlt": "Press Alt + Enter to start dragging.",
  "dragDescriptionTouch": "Double tap to start dragging.",
  "dragDescriptionVirtual": "Click to start dragging.",
  "dragDescriptionLongPress": "Long press to start dragging.",
  "dragSelectedKeyboard": function dragSelectedKeyboard(args, formatter) {
    return "Press Enter to drag ".concat(formatter.plural(args.count, {
      one: function one() {
        return "".concat(formatter.number(args.count), " selected item");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " selected items");
      }
    }), ".");
  },
  "dragSelectedKeyboardAlt": function dragSelectedKeyboardAlt(args, formatter) {
    return "Press Alt + Enter to drag ".concat(formatter.plural(args.count, {
      one: function one() {
        return "".concat(formatter.number(args.count), " selected item");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " selected items");
      }
    }), ".");
  },
  "dragSelectedLongPress": function dragSelectedLongPress(args, formatter) {
    return "Long press to drag ".concat(formatter.plural(args.count, {
      one: function one() {
        return "".concat(formatter.number(args.count), " selected item");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " selected items");
      }
    }), ".");
  },
  "dragStartedKeyboard": "Started dragging. Press Tab to navigate to a drop target, then press Enter to drop, or press Escape to cancel.",
  "dragStartedTouch": "Started dragging. Navigate to a drop target, then double tap to drop.",
  "dragStartedVirtual": "Started dragging. Navigate to a drop target, then click or press Enter to drop.",
  "endDragKeyboard": "Dragging. Press Enter to cancel drag.",
  "endDragTouch": "Dragging. Double tap to cancel drag.",
  "endDragVirtual": "Dragging. Click to cancel drag.",
  "dropDescriptionKeyboard": "Press Enter to drop. Press Escape to cancel drag.",
  "dropDescriptionTouch": "Double tap to drop.",
  "dropDescriptionVirtual": "Click to drop.",
  "dropCanceled": "Drop canceled.",
  "dropComplete": "Drop complete.",
  "dropIndicator": "drop indicator",
  "dropOnRoot": "Drop on",
  "dropOnItem": function dropOnItem(args) {
    return "Drop on ".concat(args.itemText);
  },
  "insertBefore": function insertBefore(args) {
    return "Insert before ".concat(args.itemText);
  },
  "insertBetween": function insertBetween(args) {
    return "Insert between ".concat(args.beforeItemText, " and ").concat(args.afterItemText);
  },
  "insertAfter": function insertAfter(args) {
    return "Insert after ".concat(args.itemText);
  }
};
export { $f9b46437e610cca1$exports as default };